import axios from 'axios';
import { getAccessToken } from '../Authentication/AuthenticationService';
import AppConstants from '../AppConstants';
const g2mApiUrl = AppConstants.G2M_API_URL;

export function getG2SRecordings(recordingKeys, userKey, accountKey) {
  return axios.post(
    `${g2mApiUrl}/v1/insights/products/G2W/accounts/${accountKey}/users/${userKey}/contents?client=${
      AppConstants.APP_NAME
    }`,
    { productRefKeys: recordingKeys },
    {
      headers: {
        Authorization: 'Bearer ' + getAccessToken()
      }
    }
  );
}

export function getG2SRecordingViews(contentKey) {
  return axios.get(g2mApiUrl + `/v1/insights/products/g2s/contents/${contentKey}/views`, {
    headers: {
      Authorization: 'Bearer ' + getAccessToken()
    }
  });
}



// WEBPACK FOOTER //
// ./src/Apis/InsightsReportApi.js